// extracted by mini-css-extract-plugin
export default {"sticky-header":"src-components-common-StickyHeader-___styles__sticky-header___1Tmcf"};